import React from 'react';
import {
    CircularProgress,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/DoneOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import UndeleteIcon from '@material-ui/icons/RestoreFromTrash';
import classNames from 'classnames';
// import { sortBy } from 'lodash';
import { withSnackbar } from 'notistack';
import AddIcon from '@material-ui/icons/Add';
import {
    compact,
    sortBy,
    uniq,
    uniqBy,
} from 'lodash';
// import ProductEditDialog from './productEditDialog';
// import ProductExpireDialog from './productExpireDialog';

const styles = (theme) => ({
    progressContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        width: 60,
        minHeight: 100,
        paddingTop: theme.spacing.unit * 3,
    },
    progress: {
        opacity: '.5',
    },
    tableTitleLeft: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 15,
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        alignItems: 'left',
        paddingTop: theme.spacing.unit * 2,
        fontWeight: 500,
        textTransform: 'uppercase',
        paddingBottom: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
    },
    tableTitleRight: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 15,
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        alignItems: 'right',
        paddingTop: theme.spacing.unit * 2,
        fontWeight: 500,
        textTransform: 'uppercase',
        paddingBottom: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
        cursor: 'pointer',
    },
    tableHead: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    shortDescription: {
        color: 'rgba(0, 0, 0, 0.54)',
    },
    noWrap: {
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    noWrapPlain: {
        whiteSpace: 'nowrap',
    },
    filterIcon: {
        width: 16,
    },
    filterButton: {
        marginLeft: theme.spacing.unit * 3,
    },
    orderDirectionIcon: {
        marginBottom: -10,
    },
    pageDetail: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 15,
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        paddingTop: 13,
        fontWeight: 500,
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
        textTransform: 'uppercase',
        paddingBottom: theme.spacing.unit * 2,
    },
    hidden: {
        display: 'none',
    },
    downloadIcon: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 20,
        marginLeft: 'auto',
        marginTop: 16,
        marginRight: 16,
    },
    topControls: {
        marginTop: theme.spacing.unit * 3,
    },
    noDataText: {
        padding: theme.spacing.unit * 3,
    },
    greenChip: {
        backgroundColor: 'green',
        color: 'white',
        height: theme.spacing.unit * 3,
        marginTop: -4,
    },
    blackTableIcons: {
        color: '#000000',
        fontSize: 22,
        opacity: 0.6,
    },
    colourTableIcons: {
        fontSize: 22,
        opacity: 1,
    },
    pass: {
        color: theme.palette.primary.testPass,
    },
    fail: {
        color: theme.palette.primary.testFail,
    },
    dialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    dialogContent: {
        paddingBottom: 16,
        minWidth: 600,
    },
    dialogButton: {
        marginTop: theme.spacing.unit * 4,
        marginBottom: theme.spacing.unit * 1,
    },
    dialogActions: {
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        padding: '8px 24px',
        margin: '0px 0px 0px 0px !important',
    },
    dialogText: {
        marginTop: theme.spacing.unit * 2,
    },
    dialogDivider: {
        marginBottom: theme.spacing.unit * 2,
        marginLeft: -24,
        marginRight: -24,
        marginTop: theme.spacing.unit * 2,
    },
    disabled: {
        opacity: 0.26,
    },
    tableExpiredCheckBox: {
        textAlign: 'left',
    },
    addProductButton: {
        textAlign: 'right',
    },
    dialogExpiredCheckBox: {
        textAlign: 'right',
    },
    checkBox: {
        fontSize: 14,
    },
    searchAdornment: {
        // marginTop: 4,
        // marginBottom: 4,
        margin: 'none',
        padding: 'none',
    },
    searchBox: {
        marginBottom: 16,
    },
    searchContainer: {
        paddingLeft: 48,
        textAlign: 'center',
    },
    clearButton: {
        marginTop: 8,
    },
    newButton: {
        marginTop: 8,
    },
    expiredCheckbox: {
        marginTop: 8,
    },
    searchMenuFormControl: {
        marginRight: theme.spacing.unit * 4,
    },
    searchMenu: {
        marginBottom: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 1,
    },
});

const CustomTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        whiteSpace: 'nowrap',
    },
}))(TableCell);

class ProductsTable extends React.Component {
    state = {
        currentProduct: {},
        hideExpiredProducts: true,
        searchBoxData: {
            productTypeSubCategoryCode: 1003,
            searchString: '',
        },
        showEditProductDialog: false,
        showExpireProductDialog: false,
    };

    handleRowClick = (productCode) => {
        window.open(`/product/${productCode}/`);
    };

    // handleExpireProductClick = (productCode, event) => {
    //     event.stopPropagation();
    //     this.setState({
    //         currentProduct: this.props.products.find((product) => product.code === productCode),
    //         showExpireProductDialog: true,
    //     });
    // };

    // handleEditProductClick = (productCode, event) => {
    //     event.stopPropagation();
    //     const currentProduct = this.props.products.find((product) => product.code === productCode);
    //     this.setState({
    //         currentProduct,
    //         showEditProductDialog: true,
    //     });
    // };

    // handleCloseEditProductDialogClick = () => {
    //     this.setState({
    //         showEditProductDialog: false,
    //     });
    // };

    // handleCloseExpireProductDialogClick = () => {
    //     this.setState({
    //         showExpireProductDialog: false,
    //     });
    // };

    // handleExpireProductCloseDialogClick = () => {
    //     this.setState({
    //         showExpireProductDialog: false,
    //     });
    // };

    // handleEditProductCloseDialogClick = () => {
    //     this.setState({
    //         showEditProductDialog: false,
    //     });
    // };

    // handleExpireProduct = () => {
    //     this.setState({
    //         disableExpireProductSaveButton: true,
    //     });
    //     const payload = this.state.newPurchaseOrderData;
    //     this.props.expireProduct(this.state.currentProduct.code).then(() => {
    //         this.setState({
    //             disableExpireProductSaveButton: false,
    //             showExpireProductDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Expire Manufacturer/Supplier Success', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Expire Manufacturer/Supplier Failed', { variant: 'error' });
    //         this.setState({
    //             disableExpireProductSaveButton: false,
    //         });
    //     });
    // };

    // updateEditProductData = (event) => {
    //     const { name, value } = event.target;

    //     let formattedValue;
    //     let addressData;
    //     switch (name) {
    //     case 'address1':
    //     case 'address2':
    //     case 'townCity':
    //     case 'county':
    //     case 'postcode':
    //     case 'country':
    //         addressData = {
    //             ...this.state.editProductData.address,
    //             [name]: value,
    //         };
    //         break;
    //     default:
    //         formattedValue = value;
    //         break;
    //     }
    //     event.target.value = formattedValue;

    //     this.setState((state) => ({
    //         editProductData: {
    //             ...state.editProductData,
    //             [name]: formattedValue,
    //             address: {
    //                 ...state.editProductData.address,
    //                 ...addressData,
    //             },
    //         },
    //     }));
    // };

    // handleEditProduct = () => {
    //     this.setState({
    //         disableEditProductSaveButton: true,
    //     });
    //     const payload = this.state.editProductData;
    //     this.props.editProduct(payload).then(() => {
    //         this.setState({
    //             disableEditProductSaveButton: false,
    //             showEditProductDialog: false,
    //         });
    //         this.props.enqueueSnackbar('Manufacturer/Supplier Save', { variant: 'success' });
    //     }).catch(() => {
    //         this.props.enqueueSnackbar('Save Manufacturer/Supplier Failed', { variant: 'error' });
    //         this.setState({
    //             disableEditProductSaveButton: false,
    //         });
    //     });
    // };

    // updateEditProductDataCheckbox = (name) => (event) => {
    //     const newState = !!event.target.checked;
    //     this.setState((state) => ({
    //         editProductData: {
    //             ...state.editProductData,
    //             [name]: newState,
    //         },
    //     }));
    // };

    updateHideExpiredProductsCheckbox = () => (event) => {
        const newState = !!event.target.checked;
        this.setState({
            hideExpiredProducts: newState,
        });
    };

    updateSearchboxData = (event) => {
        const { name, value } = event.target;
        let formattedValue;
        switch (name) {
        default:
            formattedValue = value;
            break;
        }
        event.target.value = formattedValue;

        this.setState((state) => ({
            searchBoxData: {
                ...state.searchBoxData,
                [name]: formattedValue,
            },
        }));
    };

    handleClearSearchStringClick = () => {
        this.setState((state) => ({
            searchBoxData: {
                ...state.searchBoxData,
                searchString: '',
            },
        }));
    };

    handleUnexpireProduct = (productCode, event) => {
        event.stopPropagation();
        this.props.unexpireProduct(productCode).then(() => {
            this.props.enqueueSnackbar('Expire Manufacturer/Supplier Success', { variant: 'success' });
        }).catch(() => {
            this.props.enqueueSnackbar('Expire Manufacturer/Supplier Failed', { variant: 'error' });
        });
    };

    render() {
        const {
            classes,
            // errors,
            products,
            productsLoading,
        } = this.props;
        const {
            currentProduct,
            // disableEditProductSaveButton,
            // disableExpireProductSaveButton,
            // editProductData,
            hideExpiredProducts,
            searchBoxData,
            showEditProductDialog,
            showExpireProductDialog,
        } = this.state;

        const displayProducts = searchBoxData.searchString.length < 3
            ? products.reduce((acc, product) => {
                if (searchBoxData.productTypeSubCategoryCode === '') return [...acc, product];
                if ((product.productTypeSubCategoryCode || null) === searchBoxData.productTypeSubCategoryCode) return [...acc, product];
                return [...acc];
            }, [])
            : products.filter((product) => (product.manufacturer.name.toLowerCase().includes(searchBoxData.searchString.toLowerCase()))
            || ((product.productType || '').toLowerCase().includes(searchBoxData.searchString.toLowerCase()))
            || ((product.productTypeSubCategory || '').toLowerCase().includes(searchBoxData.searchString.toLowerCase()))
            || ((product.barcode || '').toLowerCase().includes(searchBoxData.searchString.toLowerCase()))
            || (product.modelNo.toLowerCase().includes(searchBoxData.searchString.toLowerCase())));

        const productTypeSubCategories = products.map((product) => (product.productTypeSubCategory ? { code: product.productTypeSubCategoryCode, name: product.productTypeSubCategory } : null));
        const displayProductTypeSubCategories = uniqBy(productTypeSubCategories.filter((productTypeSubCategory) => productTypeSubCategory), 'code');

        console.log('>>> displayProductTypeSubCategory:', displayProductTypeSubCategories);
        console.log('>>> productTypeSubCategoryCode:', searchBoxData.productTypeSubCategoryCode);

        return (
            <>
                <Grid
                    container
                    spacing={0}
                >
                    <Grid
                        item
                        xs={2}
                        className={classes.tableExpiredCheckBox}
                    >
                        <FormControlLabel
                            control={(
                                <Checkbox
                                    name="hideExpiredProducts"
                                    id="hideExpiredProducts"
                                    onChange={this.updateHideExpiredProductsCheckbox()}
                                    checked={hideExpiredProducts}
                                    value={hideExpiredProducts}
                                />
                            )}
                            classes={{ label: classes.checkBox }}
                            label="Hide Expired"
                            className={classes.expiredCheckbox}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={8}
                        className={classes.searchContainer}
                    >
                        <FormControl
                            className={classes.searchMenuFormControl}
                            variant="outlined"
                        >
                            <InputLabel htmlFor="productTypeSubCategoryCode" className={classes.inputLabel}>Sub-Category</InputLabel>
                            <Select
                                keyboard="true"
                                input={(
                                    <OutlinedInput
                                        onChange={this.updateSearchboxData}
                                        name="productTypeSubCategoryCode"
                                        id="productTypeSubCategoryCode"
                                        className={classes.searchMenu}
                                    />
                                )}
                                value={searchBoxData.productTypeSubCategoryCode || ''}
                            >
                                <MenuItem value="">All</MenuItem>
                                {sortBy(displayProductTypeSubCategories, 'name').map((displayProductTypeSubCategory) => (
                                    <MenuItem
                                        key={displayProductTypeSubCategory.code}
                                        value={displayProductTypeSubCategory.code}
                                    >
                                        {`${displayProductTypeSubCategory.name} `}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            autoFocus
                            className={classes.searchBox}
                            name="searchString"
                            id="searchString"
                            onChange={this.updateSearchboxData}
                            margin="dense"
                            variant="outlined"
                            value={searchBoxData.searchString}
                            label="Filter"
                            // inputProps={{
                            //     paddingBottom: 8,
                            //     paddingLeft: 14,
                            //     paddingRight: 14,
                            //     paddingTop: 8,
                            // }}
                            InputProps={{
                                startAdornment:
    <InputAdornment
        disableTypography
        className={classes.searchAdornment}
        position="start"
    >
        <SearchIcon />
    </InputAdornment>,
                            }}

                        />
                        <IconButton
                            className={classes.clearButton}
                            onClick={this.handleClearSearchStringClick}
                        >
                            <ClearIcon />
                        </IconButton>
                    </Grid>
                    <Grid
                        item
                        xs={2}
                        className={classes.addProductButton}
                    >
                        <IconButton
                            className={classes.newButton}
                            onClick={this.props.handleCreateProductClick}
                            // disabled={!newPurchaseOrderData.supplierCode}
                        >
                            <AddIcon />
                        </IconButton>

                    </Grid>
                </Grid>
                <Paper>
                    { productsLoading
                        ? (
                            <div className={classes.progressContainer}>
                                <CircularProgress className={classes.progress} variant="indeterminate" />
                            </div>
                        )
                        : (
                            <>
                                { products.length === 0
                                    ? (
                                        <Typography className={classes.noDataText}>
                                            No Products
                                        </Typography>
                                    )
                                    : (
                                        <>
                                            <Table className={classes.table} padding="dense">
                                                <TableHead>
                                                    <TableRow>
                                                        <CustomTableCell className={classes.tableHead}>
                                                            Barcode
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead}>
                                                            Manufacturer
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Model Number
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Colour
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Type
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Sub Category
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Cost Price Type
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="right">
                                                            Default Cost Price
                                                        </CustomTableCell>
                                                        {/* <CustomTableCell className={classes.tableHead} align="left">
                                                            Telephone Number
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Email Address
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Account Reference
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="left">
                                                            Our Account Reference
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="center">
                                                            Complete
                                                        </CustomTableCell>
                                                        <CustomTableCell className={classes.tableHead} align="center" />
                                                        <CustomTableCell className={classes.tableHead} align="center" /> */}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {sortBy(displayProducts, 'name').map((product) => (!hideExpiredProducts || (hideExpiredProducts && !product.expired)
                                                        ? (
                                                            <TableRow onClick={() => this.handleRowClick(product.code)} className={classes.row} key={product.code}>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.barcode}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.manufacturer.name}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.modelNo}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.colour}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.productType}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.productTypeSubCategory}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="center"
                                                                >
                                                                    {product.costPriceType}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="right"
                                                                >
                                                                    {['costPrices:*', 'costPrices:read'].some((scope) => this.props.user.userScopes.includes(scope))
                                                                        ? (
                                                                            <>
                                                                                £
                                                                                {product.defaultCostPrice ? product.defaultCostPrice.toFixed(2) : ''}
                                                                            </>
                                                                        ) : null}
                                                                </CustomTableCell>
                                                                {/* <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.supplier ? product.telephoneNumber : ''}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.supplier ? product.emailAddress : ''}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.supplier ? product.accountReference : ''}
                                                                </CustomTableCell>
                                                                <CustomTableCell
                                                                    className={classNames(
                                                                        classes.customTableCell,
                                                                        {
                                                                            [classes.disabled]: product.expired,
                                                                        },
                                                                    )}
                                                                    align="left"
                                                                >
                                                                    {product.supplier ? product.ourAccountReference : ''}
                                                                </CustomTableCell>
                                                                <CustomTableCell className={classes.customTableCell} align="center">
                                                                    {product.recordComplete
                                                                        ? (
                                                                            <CheckCircleIcon className={classNames(
                                                                                classes.colourTableIcons,
                                                                                {
                                                                                    [classes.pass]: product.recordComplete,
                                                                                    [classes.fail]: !product.recordComplete,
                                                                                },
                                                                            )}
                                                                            />
                                                                        )
                                                                        : (
                                                                            <WarningIcon className={classNames(
                                                                                classes.colourTableIcons,
                                                                                {
                                                                                    [classes.pass]: product.recordComplete,
                                                                                    [classes.fail]: !product.recordComplete,
                                                                                },
                                                                            )}
                                                                            />
                                                                        )}
                                                                </CustomTableCell>
                                                                <CustomTableCell className={classes.customTableCell} align="left">
                                                                    <IconButton id={product.code} onClick={(event) => this.props.handleEditProductClick(product.code, event)}>
                                                                        <EditIcon className={classes.blackTableIcons} />
                                                                    </IconButton>
                                                                </CustomTableCell>
                                                                <CustomTableCell className={classes.customTableCell} align="left">
                                                                    {!product.expired
                                                                        ? (
                                                                            <IconButton id={product.code} onClick={(event) => this.props.handleExpireProductClick(product.code, event)}>
                                                                                <DeleteIcon className={classes.blackTableIcons} />
                                                                            </IconButton>
                                                                        )
                                                                        : (
                                                                            <IconButton id={product.code} onClick={(event) => this.handleUnexpireProduct(product.code, event)}>
                                                                                <UndeleteIcon className={classes.blackTableIcons} />
                                                                            </IconButton>
                                                                        )}
                                                                </CustomTableCell> */}
                                                            </TableRow>
                                                        )
                                                        : ''))}
                                                </TableBody>
                                            </Table>
                                        </>
                                    )}
                            </>
                        )}
                </Paper>

                {/* <ProductEditDialog
                    handleCloseEditProductDialogClick={this.handleCloseEditProductDialogClick}
                    product={currentProduct}
                    productLoading={productsLoading}
                    showEditProductDialog={showEditProductDialog}
                    passNewProduct={this.props.passNewProduct}
                />
                <ProductExpireDialog
                    handleCloseExpireProductDialogClick={this.handleCloseExpireProductDialogClick}
                    handleExpireProductCloseDialogClick={this.handleExpireProductCloseDialogClick}
                    product={currentProduct}
                    productLoading={productsLoading}
                    passNewProduct={this.props.passNewProduct}
                    showExpireProductDialog={showExpireProductDialog}
                /> */}
            </>

        );
    }
}

export default withSnackbar(withStyles(styles)(ProductsTable));
